// Copy of shared/evalFailures.js (CRA can't import outside src/) — change both together.
export const EVAL_FAILURES = [
  { key: "not_a_moment", group: "moment", label: "Nothing happens (topic, not an event)" },
  { key: "boring", group: "moment", label: "Real moment, not strong enough to post" },
  { key: "bad_footage", group: "moment", label: "Obstructed / inaudible / shaky" },
  { key: "wrong_person", group: "moment", label: "Not the streamer's moment" },
  { key: "starts_late", group: "cut", label: "Starts late — misses the incident/setup" },
  { key: "starts_early", group: "cut", label: "Slow start — preamble before the incident" },
  { key: "ends_early", group: "cut", label: "Cuts off the payoff / reaction" },
  { key: "ends_late", group: "cut", label: "Dead tail / drifts into next topic" },
  { key: "mid_sentence", group: "cut", label: "Cuts someone off mid-sentence" },
  { key: "title_false", group: "presentation", label: "Title isn't true" },
  { key: "title_weak", group: "presentation", label: "Title weak / off-style" },
  { key: "render_issue", group: "presentation", label: "Render bug (audio, captions, layout)" },
  { key: "duplicate", group: "ignore", label: "Same moment as another clip" },
];

// Content genres — keys match models/EvalSource.js and eval_score.GENRES.
export const GENRES = [
  { key: "gaming", label: "Gaming" },
  { key: "just_chatting", label: "Just Chatting" },
  { key: "talking_head", label: "Talking head" },
  { key: "irl", label: "IRL" },
  { key: "other", label: "Other" },
];
export const genreLabel = (k) => GENRES.find((g) => g.key === k)?.label || (k === "unset" ? "No genre" : k);

export const FAILURE_GROUPS = [
  { key: "moment", label: "Not a clip" },
  { key: "cut", label: "Wrong cut" },
  { key: "presentation", label: "Title / render" },
  { key: "ignore", label: "Other" },
];
export default EVAL_FAILURES;
